import styled from 'styled-components';

export const MapElement = styled.div`
    height: 100%;

    .gm-style {
        font-family: inherit;
    }

    .gm-style-iw,
    .gm-style-iw-d {
        max-width: none !important;
        padding: 0;
        overflow: visible !important;
    }

    button {
        display: none !important;
    }

    .cluster span {
        font-family: inherit;
        font-size: 16px;
    }
`;
